<template>
  <div id="events-grid">
    <Loader :visible="loading"></Loader>
    <div class="asd-well">
      <div class="container">
        <div class="row">
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-6">
                <input type="text" v-model="filters.name_cont"
                  class="form-control asd-input"
                  placeholder="Evento"/>
              </div>
              <div class="col-md-3">
                <select v-model="filters.month_eq" class="form-select asd-select">
                  <option value="">Mes</option>
                  <option v-for="(month, idx) in months" :key="idx" :value="month.value">
                    {{month.text}}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <select v-model="filters.year_eq" class="form-select asd-select">
                  <option value="">Año</option>
                  <option v-for="(year, index) in years" :key="index" :value="year">
                    {{year}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <button class="asd-button asd-button-primary asd-button-sm" @click="search">Buscar</button>
          </div>
          </div>
        </div>
      </div>
      <div class="container mt-5">
        <div v-if="hasEvents" class="row">
          <div class="col-sm-6 col-md-3" v-for="event in events" :key="event.id">
            <div class="event-card card">
              <a :href="event.external_url" v-if="event.external">
                <img :src="event.logo_url" class="card-img-top" alt="event.name" />
              </a>
              <router-link v-if="!event.external" :to="{name: 'AsdEvent', params: {id: event.identifier.toString()}}">
                <img :src="event.logo_url" class="card-img-top" alt="event.name">
              </router-link>
              <div class="card-body">
                <div class="row" v-if="event.external">
                  <div class="col-lg-7 col-7">
                    <a :href="event.external_url">
                      <p class="name">{{ event.name }}</p>
                    </a>
                    <p class="date">{{event.event_at | toLongDate}}</p>
                  </div>
                </div>
                <div class="row" v-if="!event.external">
                  <div class="col-lg-7 col-7">
                    <router-link :to="{name: 'AsdEvent', params: {id: event.identifier.toString()}}">
                      <p class="name">{{event.name}}</p>
                    </router-link>
                    <p class="date">{{event.event_at | toLongDate}}</p>
                  </div>
                  <div class="col-lg-5 col-5">
                    <div align="right" v-if="event.sale">
                      <div class="cart" @click="addToCart(event.identifier)">
                        <i class="fas fa-shopping-cart"></i>
                      </div>
                      <div v-if="event.active_pre_order">
                        <p class="price price-sm" v-if="event.price_album === 0"></p>
                        <p class="price price-sm" v-else>{{event.pre_order_item.discount_price | toCurrency}}</p>
                      </div>
                      <div v-else>
                        <p class="price price-sm" v-if="event.price_album === 0"></p>
                        <p class="price price-sm" v-else>{{ event.price_album | toCurrency }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-md-12" v-show="!loading">
            <div class="alert alert-primary" role="alert">
              {{ $t("events.notFound") }}
            </div>
          </div>
        </div>
        <div class="row mb-50" v-show="!loading">
          <div class="col-lg-12">
            <div align="center" v-if="events !== false">
              <button @click="nextPage" class="button-plus">
                {{ $t("events.loadMore") }}
              </button>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Loader from '../../components/Loader'
import ShoppingCart from "../../models/ShoppingCart"

export default {
  name: "Events",
  data() {
    return {
      page: '1',
      events: [],
      filters: {
        name_cont: '',
        year_eq: '',
        month_eq: '',
      },
      loading: true,
      filter_state: false,
      shoppingCart: new ShoppingCart(),
      years: ['2019', '2020', '2021', '2022'],
      months: [
        {value: '01', text: 'Enero'},
        {value: '02', text: 'Febrero'},
        {value: '03', text: 'Marzo'},
        {value: '04', text: 'Abril'},
        {value: '05', text: 'Mayo'},
        {value: '06', text: 'Junio'},
        {value: '07', text: 'Julio'},
        {value: '08', text: 'Agosto'},
        {value: '09', text: 'Septiembre'},
        {value: '10', text: 'Octubre'},
        {value: '11', text: 'Noviembre'},
        {value: '12', text: 'Diciembre'}
      ]
    }
  },
  components: {
    Loader
  },
  async created() {
    this.page = (this.$route.query.page) ? this.$route.query.page : this.page
    this.setFilter("month_eq")
    this.setFilter("year_eq")
    this.setFilter("name_cont")
    await this.getEvents()
  },
  methods: {
    async fetch() {
      try {
        const response = await this.$http.get(`/api/v2/events/`, {
          params: this.queryParams
        })

        if (response.status == 200 || response.status == 304) {
          return response.data.events
        } else {
          return []
        }
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async getEvents() {
      this.loading = true
      const events = await this.fetch(this.filtersParams)
      this.events.push.apply(this.events, events)
      this.loading = false
    },
    async search() {
      this.page = 1
      this.events = []
      this.$router.push({query: this.queryParams})
    },
    async nextPage() {
      this.page = parseInt(this.page) + 1
      await this.getEvents()
    },
    async addToCart(eventId) {
      const params = {event_id: eventId, photo_id: null}
      this.$alertify.success(this.$t("checkout.addedItem"))
      let add = await this.shoppingCart.addItem(params)
      this.$root.$emit("addItemToCart", params)
    },
    setFilter(name) {
      let param = this.$route.query[`q[${name}]`]
      this.filters[name] = (param) ? param : ""
    }
  },
  computed: {
    hasEvents() {
      return this.events.length > 0
    },
    queryParams() {
      return {
        "page": this.page,
        "q[month_eq]": this.filters.month_eq,
        "q[name_cont]": this.filters.name_cont,
        "q[year_eq]": this.filters.year_eq
      }
    },
    more() {
      return this.events.length > 0
    }
  }
}
</script>

<style lang="scss">
  .price-sm {
    font-size: 16px !important;
  }
</style>
